import Vue from "vue";
import App from "./App.vue";

// Vuesax Component Framework
import Vuesax from "vuesax";
import "material-icons/iconfont/material-icons.css"; //Material Icons
import "vuesax/dist/vuesax.css"; // Vuesax
Vue.use(Vuesax);

// axios
import axios from "./axios.js";
Vue.prototype.$http = axios;

// ACL
import acl from "./acl/acl";

// VeeValidate
import VeeValidate, { Validator } from "vee-validate";
import ru from "vee-validate/dist/locale/ru.js";

Validator.localize({ ru: ru });
Vue.use(VeeValidate, { locale: "ru" });

// Filters
import "./filters/filters.js";

// Theme Configurations
import "../themeConfig.js";

// Globally Registered Components
import "./globalComponents.js";

// Styles: SCSS
import "./assets/scss/main.scss";

// Tailwind
import "@/assets/css/main.css";

// Vue Router
import router from "./router";

// Vuex Store
import store from "./store/store";

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from "vue2-hammer";
Vue.use(VueHammer);

import _ from "lodash";
Vue.use(_);

//Vue Input Mask
import VueTheMask from "vue-the-mask";
Vue.use(VueTheMask);

//Vue Select
import vSelect from "vue-select";
Vue.component("v-select", vSelect);

// PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";

// Feather font icon
require("./assets/css/iconfont.css");

import Notifications from "vue-notification";
Vue.use(Notifications);

//Firebase Push
import LoadScript from "vue-plugin-load-script";
Vue.use(LoadScript);

var firebaseConfig = {
  apiKey: "AIzaSyB1gkKWTgLASLhqWov691XZwE61Dun0bdk",
  authDomain: "grafapp-6ef74.firebaseapp.com",
  projectId: "grafapp-6ef74",
  storageBucket: "grafapp-6ef74.appspot.com",
  messagingSenderId: "205764234328",
  appId: "1:205764234328:web:ab2b29095ee565a76d0e2d"
};

import api from "@/api/index";

Promise.resolve()
  .then(() =>
    Vue.loadScript("https://www.gstatic.com/firebasejs/7.17.2/firebase-app.js")
  )
  .then(() =>
    Vue.loadScript(
      "https://www.gstatic.com/firebasejs/7.17.2/firebase-messaging.js"
    )
  )
  .then(() => {
    window.firebase.initializeApp(firebaseConfig);
    const messaging = window.firebase.messaging();

    messaging
      .requestPermission()
      .then(function() {
        return messaging.getToken();
      })
      .then(token => {
        Notification.requestPermission().then(function(result) {
          let fcmToken = localStorage.getItem("fcm_token"),
            user = localStorage.getItem("userInfo");

          if (result == "granted" && token) {
            localStorage.setItem("fcm_token", token);

            // Токен изменился (новая установка, смена Firebase-проекта, ротация) -
            // отправляем на сервер, если пользователь авторизован.
            if (fcmToken !== token && user !== null) {
              api.users.updateFCMTokenUser(token).data;
            }
          }
        });
      })
      .catch(err => {
        console.log(err);
        if (!("Notification" in window)) {
          Vue.notify({
            title: "Ошибка",
            text: "Ваш браузер не поддерживает уведомления",
            duration: 10000,
            type: "error"
          });
        } else {
          Vue.notify({
            title: "Выключены уведомления в браузере",
            text: "Включите уведомления в браузере, чтобы получать уведомления",
            duration: -1,
            type: "error"
          });
        }
      });

    messaging.onMessage(function(payload) {
      navigator.serviceWorker.register("/firebase-messaging-sw.js");
      Notification.requestPermission(function(result) {
        if (result === "granted") {
          navigator.serviceWorker.ready
            .then(function(registration) {
              const data = { ...payload.notification, ...payload.data };
              const notificationTitle = data.title;
              const notificationOptions = {
                body: data.body,
                icon: data.icon,
                image: data.image,
                click_action: data.click_action,
                requireInteraction: false,
                data
              };

              store.dispatch("getNotifications", { page: 1 });

              Vue.notify({
                group: data.kind == "security" ? "security" : null,
                title: data.title,
                text: data.body,
                duration: -1,
                width: data.kind == "security" ? "50%" : 300,
                type: data.kind == "security" ? "security" : "success",
                animationName:
                  data.kind == "securityAnimation" ? "sec_op" : null
              });

              return registration.showNotification(
                notificationTitle,
                notificationOptions
              );
            })
            .catch(function(error) {
              console.log("ServiceWorker registration failed", error);
            });
        }
      });
    });
  });

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';
import ApiPlugin from "./plugins/api";
import LoadPlugin from "./plugins/load";

Vue.use(ApiPlugin);
Vue.use(LoadPlugin);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  acl,
  render: h => h(App)
}).$mount("#app");
